import { PLAYFIELD } from '../core/Constants';

/**
 * Laser projectile fired from Vaus craft
 */
export class Laser {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.width = 4;
    this.height = 12;
    this.speed = 11.0;
    this.destroyed = false;
  }

  update(dt) {
    this.y -= this.speed * dt * 60;
    if (this.y < PLAYFIELD.top) {
      this.destroyed = true;
    }
  }

  getBounds() {
    return {
      left: this.x - this.width / 2,
      right: this.x + this.width / 2,
      top: this.y,
      bottom: this.y + this.height,
    };
  }

  checkCollision(brick) {
    if (brick.destroyed) return false;
    const bBounds = brick.getBounds();
    const lBounds = this.getBounds();

    return (
      lBounds.right >= bBounds.left &&
      lBounds.left <= bBounds.right &&
      lBounds.top <= bBounds.bottom &&
      lBounds.bottom >= bBounds.top
    );
  }
}
